import { useEffect } from "react"
import { DEFAULT_PAGE_TITLE } from "../utilties/StringConstants"
import ReactGA from "react-ga4"

const PageWrapper = ({ title, children, gaPageTitle }) => {
	useEffect(() => {
		if(title) {
			document.title = title
		}
		else {
			document.title = DEFAULT_PAGE_TITLE
		}

	}, [title])

	// useEffect(() => {
	// 	if(gaPageTitle) {
	// 		ReactGA.send({ hitType: "pageview", pageTitle: gaPageTitle });
	// 	}

	// }, [gaPageTitle])

	return children
}

export default PageWrapper